import api from "./index";

export const getAutoReplyTemplates = (params = {}) =>
  api.get("role-management/users-templates/", { params });

// GET single auto reply template by ID
export const getAutoReplyTemplate = (id) =>
  api.get(`auto-replies/templates/${id}/`);

// CREATE new auto reply template
export const createAutoReplyTemplate = (templateData) =>
  api.post("role-management/users-templates/", templateData);

// UPDATE auto reply template
export const updateAutoReplyTemplate = (id, templateData) =>
  api.put(`role-management/users-templates/${id}/`, templateData);

// DELETE auto reply template
export const deleteAutoReplyTemplate = (id) =>
  api.delete(`role-management/users-templates/${id}/`);

